if (!customElements.get('akr-insta')) {
  customElements.define(
    'akr-insta',
    class AkrInsta extends HTMLElement {
      connectedCallback() {
        this.pauseButton = this.querySelector('.akr-insta__pause');
        if (!this.pauseButton) return;

        this.onPauseClick = () => {
          const paused = this.classList.toggle('is-paused');
          this.pauseButton.setAttribute('aria-pressed', paused);
        };
        this.pauseButton.addEventListener('click', this.onPauseClick);
      }

      disconnectedCallback() {
        this.pauseButton?.removeEventListener('click', this.onPauseClick);
      }
    }
  );
}
